class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // EXP-2026-029: push-notification behaviour (auto-dismiss, pause on hover/focus, no focus trap)
    this.dismissDelay = 4000;
    this.dismissTimer = null;
    this.notification.addEventListener('mouseenter', () => this.isVariant() && this.clearDismissTimer());
    this.notification.addEventListener('mouseleave', () => this.isVariant() && this.scheduleDismiss());
    this.notification.addEventListener('focusin', () => this.isVariant() && this.clearDismissTimer());
    this.notification.addEventListener('focusout', (evt) => {
      if (this.isVariant() && !this.notification.contains(evt.relatedTarget)) this.scheduleDismiss();
    });

    this.notification.addEventListener('transitionend', (evt) => {
      if (this.isVariant() && evt.target === this.notification && evt.propertyName === 'transform' && !this.notification.classList.contains('active')) {
        this.notification.classList.add('fade-out-finished');
      }
    });

    this.querySelectorAll('.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  isVariant() {
    return document.body.classList.contains('exp-2026-029');
  }

  clearDismissTimer() {
    clearTimeout(this.dismissTimer);
    this.dismissTimer = null;
  }

  scheduleDismiss() {
    this.clearDismissTimer();
    if (this.notification.matches(':hover') || this.notification.contains(document.activeElement)) return;
    this.dismissTimer = setTimeout(() => this.close(), this.dismissDelay);
  }

  openPushNotification() {
    // Already visible: content was replaced, only restart the timer (no new animation)
    if (!this.notification.classList.contains('active')) {
      this.notification.removeAttribute('aria-modal');
      this.notification.setAttribute('role', 'status');
      this.notification.removeAttribute('tabindex');
      this.notification.classList.remove('fade-out-finished');
      this.notification.classList.add('animate', 'active');
      document.body.addEventListener('click', this.onBodyClick);
    }
    document.getElementById('sticky-atc-bar')?.classList.add('lower-z-index');
    this.scheduleDismiss();
  }

  open() {
    if (this.isVariant()) return this.openPushNotification();

    document.getElementById('sticky-atc-bar').classList.add('lower-z-index');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.clearDismissTimer();
    this.notification.classList.remove('active');
    // Reduced motion has no transform transition, so no transitionend to wait for
    if (this.isVariant() && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.notification.classList.add('fade-out-finished');
    }
    document.getElementById('sticky-atc-bar')?.classList.remove('lower-z-index');
    document.body.removeEventListener('click', this.onBodyClick);
    if (!this.isVariant()) removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        let sectionSelector = section.selector;
        if (sectionSelector == '[id="cart-notification-product-undefined"]') {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
        } else if (parsedState.sections !== null) {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], sectionSelector);
        }
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    // EXP-2026-029: adding another product keeps the notification open (content updates, timer restarts)
    if (this.isVariant() && target.closest('product-form, .quick-add, quick-add-modal')) return;
    let quickAddModal = document.querySelector('.quick-add-modal__content-info');
    let quickAddCloseModal = document.querySelector('.quick-add-modal__toggle');
    if (target !== this.notification && !target.closest('cart-notification') && 
    target !== quickAddModal && !target.closest('.quick-add-modal__content-info') &&
    target !== quickAddCloseModal) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
